/** Typed Behavior outputs supported by the trusted desktop ticket host. */
export const ENTRY_POLICY_ACTIONS = {
  customEntryEligible: "boolean",
  customEntryMinimum: "number",
  customEntryMaximum: "number",
  customEntryStep: "number",
  customEntryAllowWhileCalled: "boolean",
  customEntryUnlimitedChanges: "boolean",
  customEntryReviewChanges: "boolean",
  customEntryMaxChanges: "number",
  customEntryTicketReference: "string",
} as const;
export const ENTRY_POLICY_INPUTS = [
  { key: "field", type: "TEXT" },
  { key: "called", type: "BOOLEAN" },
  { key: "attemptNumber", type: "NUMBER" },
  { key: "fieldValue", type: "NUMBER" },
  { key: "changes", type: "NUMBER" },
] as const;

/** Policy graphs may read data and emit policy values, never mutate a competition. */
export function isEntryPolicyGraph(graph: {
  nodes: unknown[];
  connections: unknown[];
}): boolean {
  return (
    graph.nodes.length > 0 &&
    graph.nodes.length <= 1000 &&
    graph.connections.length <= 2000 &&
    graph.nodes.every((raw) => {
      if (!raw || typeof raw !== "object") return false;
      const node = raw as Record<string, unknown>;
      if (node.type === "variable" || node.type === "operator") return true;
      if (node.type === "event") return node.kind === "onLoad";
      if (node.type === "control")
        return ["ifElse", "mergeFlows"].includes(String(node.controlType));
      return (
        node.type === "action" &&
        node.kind === "set" &&
        typeof node.key === "string" &&
        Object.prototype.hasOwnProperty.call(ENTRY_POLICY_ACTIONS, node.key)
      );
    })
  );
}
